import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import QrCode from "../../../../../shared/qr-code/qr-code";
import styles from "./create-qr-code-modal.module.scss";

interface CreateQrCodeModalProps {
  cityName: string;
  reportId: number;
  onClose: () => void;
}

const CreateQrCodeModal: FC<CreateQrCodeModalProps> = ({
  cityName,
  reportId,
  onClose,
}) => {
  const { t } = useTranslation();
  const baseUrl = window.location.origin;
  return (
    <Modal onClose={onClose}>
      <h2 className={styles.cityName}>
        {t("create-qr-code-modal.title", { cityName })}
      </h2>
      <QrCode
        sizeQr={174}
        visibleLinks={false}
        href={`${baseUrl}${process.env.PUBLIC_URL}/repository/reports?ids=${reportId}`}
      />
    </Modal>
  );
};

export default CreateQrCodeModal;
